"use client";

import { storyblokEditable } from "@storyblok/react";
import Image from "next/image";
import CountryFlag from "react-country-flag";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { sbBlok } from "@/types/sb-types";
import "swiper/css";
import { motion } from "framer-motion";

const PlayerCarousel = ({ blok }: sbBlok) => {
  return (
    <div className="grid-container">
      <div className="col-start-1 col-span-4 lg:col-start-2 lg:col-span-14 2xl:col-start-2 2xl:col-span-30">
        <Swiper
          {...storyblokEditable(blok)}
          className="py-10 px-0"
          spaceBetween={10}
          slidesPerView="auto"
          centeredSlides
          pagination={{ clickable: true }}
          modules={[Pagination]}
          cssMode
          grabCursor
          speed={100}
          allowTouchMove={false}
          onClick={(swiper, e) => {
            e.stopPropagation();
            swiper.clickedIndex !== undefined &&
              swiper.slideTo(swiper.clickedIndex, 100);
          }}
        >
          {blok?.player_carousel_items?.map((i: sbBlok, index: number) => {
            return (
              <SwiperSlide
                key={i._uid}
                className="flex flex-col justify-center !w-[250px] rounded-[10px] 2xl:!w-[320px]"
              >
                {({ isActive }) => (
                  <motion.div
                    initial={{ opacity: 0.4, scale: 0.9 }}
                    animate={{
                      opacity: isActive ? 1 : 0.4,
                      scale: isActive ? 1 : 0.9,
                    }}
                    transition={{
                      ease: "easeInOut",
                    }}
                  >
                    <div className="relative h-[170px] 2xl:h-[215px] after:content-[''] after:absolute after:-bottom-[10px] after:w-full after:h-[55px] after:bg-[#090909] after:blur-[25px]">
                      <Image
                        src={i.image.filename}
                        alt={i.image.alt}
                        fill
                        sizes="100vw"
                        className="object-cover rounded-t-[10px]"
                      />
                    </div>
                    <div className="relative bottom-2.5 w-full h-[210px] rounded-[10px] bg-[linear-gradient(180deg,var(--color-tm-c-gray-700)_0%,#282828_100%)] px-[15px] pt-[5px] pb-[30px] text-center flex flex-col gap-2.5 2xl:!h-[250px]">
                      {i?.preview_text ? (
                        <>
                          <div className="text-tm-c-gray-500 text-xs tracking-[0.36px] 2xl:text-[15px] 2xl:tracking-[0.45px]">
                            Season {i.season_number}
                          </div>
                          <div className="text-[15px] tracking-[0.45px] 2xl:text-xl 2xl:tracking-[0.6px]">
                            {i?.preview_text}
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="text-tm-c-gray-500 text-xs tracking-[0.36px] 2xl:text-[15px] 2xl:tracking-[0.45px]">
                            Season {i.season_number}
                          </div>
                          <div>{i?.name}</div>
                          <div className="flex items-center justify-center gap-[15px] text-xs 2xl:text-[15px]">
                            <CountryFlag
                              countryCode={i?.country_code}
                              className="text-3xl"
                              svg
                            />
                            {i?.country}
                          </div>
                          <div className="text-xs tracking-[0.36px] mt-[25px] 2xl:text-[15px] 2xl:tracking-[0.45px] 2xl:mt-9">
                            <div className="flex justify-between">
                              <div>Earnings</div>
                              <div>{i?.earnings}</div>
                            </div>
                            <div className="flex justify-between">
                              <div>Hcp</div>
                              <div>{i?.hcp}</div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </motion.div>
                )}
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};

export default PlayerCarousel;
